import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../services/error-handler.service';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {

  // Configure these parameters based on your requirements
  private readonly maxRetries = 3;
  private readonly retryableStatusCodes = [408, 429, 500, 502, 503, 504];

  constructor(private readonly errorHandlerService: ErrorHandlerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(

      retry({
        count: this.maxRetries,
        delay: (error, retryCount) => {
          // Only retry for specific status codes
          if (
            error instanceof HttpErrorResponse &&
            this.retryableStatusCodes.includes(error.status)
          ) {
            console.log(`Retrying request (${retryCount}/${this.maxRetries}): ${request.url}`);

            // Exponential backoff: 1s, 2s, 4s, etc.
            const delayMs = Math.pow(2, retryCount - 1) * 1000;

            // Add some randomness to prevent all clients retrying simultaneously
            const jitter = Math.random() * 100;

            // Use timer instead of creating a custom Observable
            return timer(delayMs + jitter);
          }

          // Don't retry for other errors
          return throwError(() => error);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // Handle errors after all retries are exhausted
        console.error('All retries failed or error not retryable:', error);
        this.errorHandlerService.handleError(error);
        return throwError(() => error);
      })
    );
  }
}